export default "__VITE_ASSET__75d2ca7a__"